import styled from '@emotion/styled';
import { SmallText } from 'ds/components/typography';

export const SectionWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing(4)};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  background: ${({ theme }) => theme.colors.neutrals.white};
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    padding: ${theme.spacing(4)} ${theme.spacing(2)} ${theme.spacing(2)};
  `}
  border: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
  box-shadow: ${({ theme }) => theme.shadow.level7};
  & [data-auto="radio-button"] {
    font-size: 15px;
  }
`;

export const Title = styled.div<{ isSaved: boolean; isActive: boolean }>`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  text-align: right;
  font-size: 17px;
  font-weight: 700;
  line-height: 22px;
  ${({ isSaved, theme, isActive }) => isSaved || isActive ? `
    color: ${theme.colors.neutrals.grey1};
  ` : `
    color: ${theme.colors.neutrals.grey5};
  `}
`;

export const Subtitle = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  text-align: right;
`;

export const NameSection = styled(SmallText)<{ isSaved: boolean; isActive: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(3)};
  cursor: pointer;
  ${({ isActive }) => !isActive ? `
    flex-direction: row;
    margin-bottom: 0;
  ` : ''}
  ${({ isSaved, isActive }) => isSaved ? `
    cursor: pointer;
  ` : `
    cursor: ${isActive ? 'default' : 'not-allowed'};
  `}
`;

export const Nav = styled.div`
  margin-top: ${({ theme }) => theme.spacing(6)};
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Page = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.neutrals.grey11};
`;

export const Header = styled.div`
  padding: ${({ theme }) => theme.spacing(3)};
  display: flex;
  justify-content: center;
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    position: sticky;
    top: 0;
  `}
  background-color: ${({ theme }) => theme.colors.brand.madlanGreen};
  & svg {
    path {
      fill: ${({ theme }) => theme.colors.neutrals.white};
    }
  }
`;

export const Content = styled.div`
  max-width: 560px;
  padding: ${({ theme }) => `0 ${theme.spacing(3)}`};
  margin: 0 auto;
`;

export const MainTitle = styled.div`
  color: ${({ theme }) => theme.colors.brand.darker};
  text-align: center;
  font-size: 40px;
  font-weight: 700;
  line-height: normal;
  margin-top: ${({ theme }) => theme.spacing(12)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    font-size: 25px;
    line-height: 32px;
    margin-top: ${theme.spacing(5)};
    margin-bottom: ${theme.spacing(1.25)};
  `}
`;

export const MainSubtitle = styled.div`
  color: ${({ theme }) => theme.colors.brand.secondary};
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  line-height: 30px;
  max-width: 427px;
  margin: 0 auto ${({ theme }) => theme.spacing(5)};
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    font-size: 15px;
    margin: 0 auto ${theme.spacing(3)};
    font-weight: 400;
    line-height: 24px;
  `}
`;
